// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1jgvZ","inner":"Footer_inner__2uKkQ","nextIcon":"Footer_nextIcon__NGJJn","innerLeft":"Footer_innerLeft__3KglS"};